export const CATEGORIES = {
  3: 'tourers',
  4: 'tents',
  6: 'caravans',
  7: 'lodges',
  10: 'motorhomes',
  13: 'rent-a-tent',
}
